import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class SearchService {
    protected subject;
    protected searchObj;
    protected searchTermSubject;

    constructor() {
        this.searchObj = {results: {}, searchTerm: ''};
        this.searchTermSubject = new BehaviorSubject('');
        this.subject = new BehaviorSubject(this.searchObj);
    }

    getSearchObj() {
        return this.searchObj;
    }

    getSubject() {
        return this.subject;
    }

    getSearchTermSubject() {
        return this.searchTermSubject;
    }

    setSearchTerm(searchTerm) {
        this.searchObj.searchTerm = searchTerm;
        this.searchTermSubject.next(searchTerm);
    }

    addSearchResult(module, content) {
        this.searchObj.results[module] = content;
        this.subject.next(this.searchObj);
    }
}



// WEBPACK FOOTER //
// ./src/app/search/search.service.ts